// TODO: REMOVE THIS FILE AFTER EXPOSING THE SHORTHAND MAPPINGS TO THE HOST

import { CSS_PROPERTIES } from '@wix/component-protocol/schema';
import type { Builder } from '@wix/document-services-types';
import { CssPropertyType } from '../../types';
import {
  BORDER_COLOR_CSS_PROPERTY_TYPES,
  BORDER_STYLE_CSS_PROPERTY_TYPES,
  BORDER_WIDTH_CSS_PROPERTY_TYPES,
  GAP_CSS_PROPERTY_TYPES,
  PADDING_CSS_PROPERTY_TYPES,
  getFontPropeties,
} from '../../../../apis/services/editActionsServices/nativeActions/globalDesign/constants';

export interface ShortHandExpansionDef {
  propertyName: string;
  cssPropertyType: Builder.StyleType;
}

type PropertyMap = Record<string, Set<string>>;

const getBorderExpansion = (propertyName: string): ShortHandExpansionDef[] => [
  {
    propertyName: `${propertyName}Width`,
    cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderWidth,
  },
  {
    propertyName: `${propertyName}Style`,
    cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStyle,
  },
  {
    propertyName: `${propertyName}Color`,
    cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderColor,
  },
];

export const CSS_SHORTHAND_MAPPINGS: Record<string, ShortHandExpansionDef[]> = {
  // Border properties - all follow the same pattern
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.border]: getBorderExpansion('border'),
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRight]:
    getBorderExpansion('borderRight'),
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderLeft]:
    getBorderExpansion('borderLeft'),
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTop]: getBorderExpansion('borderTop'),
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottom]:
    getBorderExpansion('borderBottom'),
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineStart]:
    getBorderExpansion('borderInlineStart'),
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineEnd]:
    getBorderExpansion('borderInlineEnd'),
  // Border width expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderWidth]: [
    {
      propertyName: 'borderTopWidth',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopWidth,
    },
    {
      propertyName: 'borderBottomWidth',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopWidth,
    },
    {
      propertyName: 'borderLeftWidth',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopWidth,
    },
    {
      propertyName: 'borderRightWidth',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopWidth,
    },
  ],

  // Border style expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStyle]: [
    {
      propertyName: 'borderTopStyle',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopStyle,
    },
    {
      propertyName: 'borderBottomStyle',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopStyle,
    },
    {
      propertyName: 'borderLeftStyle',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopStyle,
    },
    {
      propertyName: 'borderRightStyle',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopStyle,
    },
  ],

  // Border color expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderColor]: [
    {
      propertyName: 'borderTopColor',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.color,
    },
    {
      propertyName: 'borderBottomColor',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.color,
    },
    {
      propertyName: 'borderLeftColor',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.color,
    },
    {
      propertyName: 'borderRightColor',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.color,
    },
  ],

  // Border radius expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRadius]: [
    {
      propertyName: 'borderTopLeftRadius',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopLeftRadius,
    },
    {
      propertyName: 'borderTopRightRadius',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopLeftRadius,
    },
    {
      propertyName: 'borderBottomLeftRadius',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopLeftRadius,
    },
    {
      propertyName: 'borderBottomRightRadius',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopLeftRadius,
    },
  ],

  // Padding expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.padding]: [
    {
      propertyName: 'paddingTop',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingTop,
    },
    {
      propertyName: 'paddingBottom',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingTop,
    },
    {
      propertyName: 'paddingLeft',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingTop,
    },
    {
      propertyName: 'paddingRight',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingTop,
    },
  ],

  // Margin expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.margin]: [
    {
      propertyName: 'marginTop',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginTop,
    },
    {
      propertyName: 'marginBottom',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginTop,
    },
    {
      propertyName: 'marginLeft',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginTop,
    },
    {
      propertyName: 'marginRight',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginTop,
    },
  ],

  // Background expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.background]: [
    {
      propertyName: 'backgroundImage',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundImage,
    },
    {
      propertyName: 'backgroundPosition',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundPosition,
    },
    {
      propertyName: 'backgroundSize',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundSize,
    },
    {
      propertyName: 'backgroundRepeat',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundRepeat,
    },
    {
      propertyName: 'backgroundAttachment',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundAttachment,
    },
    {
      propertyName: 'backgroundOrigin',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundOrigin,
    },
    {
      propertyName: 'backgroundClip',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundClip,
    },
    {
      propertyName: 'backgroundColor',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundColor,
    },
  ],

  // Overflow expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.overflow]: [
    {
      propertyName: 'overflowX',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.overflow,
    },
    {
      propertyName: 'overflowY',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.overflow,
    },
  ],

  // Font expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.font]: [
    {
      propertyName: 'fontSize',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontSize,
    },
    {
      propertyName: 'fontStyle',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontStyle,
    },
    {
      propertyName: 'fontWeight',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontWeight,
    },
    {
      propertyName: 'fontFamily',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontFamily,
    },
    {
      propertyName: 'fontVariant',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontVariant,
    },
    {
      propertyName: 'fontStretch',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontStretch,
    },
    {
      propertyName: 'lineHeight',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.lineHeight,
    },
  ],

  // Text decoration expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.textDecoration]: [
    {
      propertyName: 'textDecorationLine',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.textDecorationLine,
    },
    {
      propertyName: 'textDecorationStyle',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.textDecorationStyle,
    },
    {
      propertyName: 'textDecorationThickness',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.textDecorationThickness,
    },
    {
      propertyName: 'textDecorationColor',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.color,
    },
  ],

  // Gap expansion
  [CSS_PROPERTIES.CSS_PROPERTY_TYPE.gap]: [
    {
      propertyName: 'rowGap',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.rowGap,
    },
    {
      propertyName: 'columnGap',
      cssPropertyType: CSS_PROPERTIES.CSS_PROPERTY_TYPE.columnGap,
    },
  ],
};

const getSiblingsSet = (
  siblingMap: PropertyMap,
  properties: readonly string[],
) => {
  properties.forEach((property) => {
    if (!siblingMap[property]) {
      siblingMap[property] = new Set();
    }

    properties.forEach((siblingName) => {
      if (siblingName !== property) {
        siblingMap[property].add(siblingName);
      }
    });
  });
};

const BORDER_DIRECTIONAL_SIBLINGS: CssPropertyType[] = [
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTop,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRight,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottom,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderLeft,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineStart,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineEnd,
];

const LOGICAL_BORDER_RADIUS_SIBLINGS: CssPropertyType[] = [
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStartStartRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStartEndRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderEndStartRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderEndEndRadius,
];

const FONT_SIBLINGS: CssPropertyType[] = [
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontSize,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontWeight,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontFamily,
];

const CUSTOM_SIBLING_ARRAY: CssPropertyType[][] = [
  BORDER_DIRECTIONAL_SIBLINGS,
  LOGICAL_BORDER_RADIUS_SIBLINGS,
  FONT_SIBLINGS,
];

const getPropertySiblings = (): Record<string, Set<string>> => {
  const siblingMap: Record<string, Set<string>> = {};

  CUSTOM_SIBLING_ARRAY.forEach((siblings) => {
    getSiblingsSet(siblingMap, siblings);
  });

  Object.values(CSS_SHORTHAND_MAPPINGS).forEach((expansions) => {
    const propertyNames = expansions.map((expansion) => expansion.propertyName);

    getSiblingsSet(siblingMap, propertyNames);
  });

  return siblingMap;
};

// TODO(value-equivalents): This file currently hosts BOTH:
// - Sibling lists (used for UI behaviors)
// - Value-equivalents groups (used for ValueSet subset detection + propagation semantics)
// If/when we split responsibilities, move value-equivalents to a dedicated module.
const getValueEquivalentGroups = (): readonly (readonly string[])[] => [
  BORDER_DIRECTIONAL_SIBLINGS,
  BORDER_COLOR_CSS_PROPERTY_TYPES,
  BORDER_WIDTH_CSS_PROPERTY_TYPES,
  BORDER_STYLE_CSS_PROPERTY_TYPES,
  PADDING_CSS_PROPERTY_TYPES,
  GAP_CSS_PROPERTY_TYPES,
  getFontPropeties(),
];

let cachedPropertyEquivalentsMap: Record<string, Set<string>> | undefined;

export const getPropertyEquivalentsMap = (): Record<string, Set<string>> => {
  if (!cachedPropertyEquivalentsMap) {
    const equivalentsMap: Record<string, Set<string>> = {};

    getValueEquivalentGroups().forEach((group) => {
      getSiblingsSet(equivalentsMap, group);
    });

    cachedPropertyEquivalentsMap = equivalentsMap;
  }

  return cachedPropertyEquivalentsMap;
};

export const PROPERTY_SIBLINGS_MAP = getPropertySiblings();
